import React, { Component } from 'react';
import { connect } from 'react-redux';

import {Grid} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { Helmet } from "react-helmet";
import * as api from "../../api";
import ClosingPriceFilters from "./closing-price-filter";
import {from} from "linq";
import MonthlyUnitLineChart from "../../components/charts/custom/monthly-unit-line-chart";
import {ChartColors} from "../../components/charts/constants/chart-color-constants";
import moment from "moment";

function mapStateToProps(state) {
    return {

    };
}

const commodityLabels = {
    "nbp gas": "Pence per Therm (p/Th)",
    "uk baseload": "Pounds per Megawatt (£/MW)",
    "uk peak": "Pounds per Megawatt (£/MW)",
    "heavy fuel oil": "Dollars per Metric Ton ($/MT)",
    "ultra-low sulfur diesel": "Dollars per Metric Ton ($/MT)"
}

class ClosingPrices extends Component {

    constructor(props) {
        super(props);
        this.state = {
            closingPrices: [],
            commodities: [],
            periods: [],
            currentFilter: {},
            chartData: [],
            chartUnits: [],
            isLoading: false
        };

        this.refreshData()
            .then(() => {
                this.generateOptions();
                this.generateChartData();
            });
    }

    refreshData = () => {
        this.setState({isLoading: true});
        const fromDate = this.state.currentFilter.fromDate ? moment(this.state.currentFilter.fromDate).format("YYYY/MM/DD") : "";
        const toDate = this.state.currentFilter.toDate ? moment(this.state.currentFilter.toDate).format("YYYY/MM/DD") : "";
        return api.getClosingPriceList(fromDate,toDate)
            .then(data => this.setState({ closingPrices: from(data), isLoading: false }));
    }

    generateOptions = () => {
        const takeTheKey = (key) => key;

        const enumerable = this.state.closingPrices;

        const commodities = enumerable
            .groupBy(x => x.name,null, takeTheKey)
            .toArray();

        const periods = enumerable
            .groupBy(x => x.period, null, takeTheKey)
            .toArray();

        this.setState({ commodities, periods });
    }

    onFilterUpdated = (filters) => {
        this.setState({currentFilter: filters}, () => {
            this.refreshData().then(this.generateChartData);
        });
    };

    generateChartData = () => {
        const filter = this.state.currentFilter;
        this.setState({chartData: []});

        if(filter.commodity == null || filter.periods.length === 0)
        { return; }

        const chartData = this.state.closingPrices
            .where(x => filter.periods.indexOf(x.period) >= 0 && filter.commodity === x.name)
            .orderBy(x => x.date)
            .groupBy(x => x.date, null, (key, group) => {
                const result = { date: key };
                group.forEach(x => { result[x.period] = x.offerPrice; });
                return result;
            })
            .toArray();

        if(chartData.length === 1)
        { chartData.push({...chartData[0]}); }

        const availableColours = Object.values(ChartColors);
        const chartUnits = filter.periods.map(x => { return { field: x, label: x, color: availableColours.shift()}; });
        this.setState({chartData, chartUnits});
    }

    getCommodityLabel() {
        return commodityLabels[this.state.currentFilter.commodity.toLowerCase()];
    }

    render() {
        return (
            <div className="main-container">
                <Helmet>
                    <title>Insite | Inenco Closing Prices</title>
                </Helmet>
                <Grid padded stackable columns='equal'>
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Inenco Closing Prices</h2>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            <ClosingPriceFilters onFilterUpdated={this.onFilterUpdated} commodities={this.state.commodities} periods={this.state.periods} disabled={this.state.isLoading}/>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column>
                            {this.state.chartData.length > 0 &&
                            <MonthlyUnitLineChart data={this.state.chartData} dateFormat="Do MMM YY"
                                                  units={this.state.chartUnits}
                                                  title={`${this.state.currentFilter.commodity} Price`}
                                                  isLoading={this.state.isLoading}
                                                  size="medium"
                                                  label={this.getCommodityLabel()}/>
                            }
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(ClosingPrices);